import { z } from 'zod/mini';

// Esquemas de autenticación (patrón VLT-212). Mensajes = claves i18n.
// 29-oct: zod 4 en su versión «mini» (la 3.x tiene una vulnerabilidad alta sin
// arreglo, GHSA-mrhx-c7xc-m3w5; la mini pesa ~10 KB menos que la clásica).
// Estándar Cassimmit punto 52 (29-oct): toda contraseña NUEVA lleva mínimo
// 10 caracteres. El login no la exige: las cuentas creadas con 8 o 9 siguen
// entrando y se les pide la nueva regla al cambiarla.
export const PASSWORD_MIN = 10;
const newPassword = z.string().check(z.minLength(PASSWORD_MIN, 'forms.errors.passwordMin'));
const email = z.string().check(z.trim(), z.email('forms.errors.email'));
// Puntos 61 a 63: casilla sin marcar de antemano; sin ella no hay cuenta.
const acceptLegal = z.literal(true, 'forms.errors.acceptLegal');
const fullName = z.string().check(z.trim(), z.minLength(3, 'forms.errors.nameMin'));

export const loginSchema = z.object({
  email,
  password: z.string().check(z.minLength(1, 'forms.errors.passwordRequired')),
});
export type LoginInput = z.infer<typeof loginSchema>;

export const registerSchema = z.extend(loginSchema, {
  password: newPassword,
  acceptLegal,
  fullName,
  orgName: z.string().check(z.trim(), z.minLength(2, 'forms.errors.orgMin')),
  // Cada cuenta es un cliente de VaulTex: empresa preparadora o persona
  // física independiente que llena taxes (aclaración del propietario 3-sep).
  accountType: z.enum(['firm', 'independent']),
});
export type RegisterInput = z.infer<typeof registerSchema>;

// VLT-405 · registro por invitación de equipo (/login?invite=1): sin nombre
// de firma ni tipo de cuenta — el perfil nace en la organización invitante
// (trigger 0023) al registrarse con el correo invitado.
export const inviteRegisterSchema = z.extend(loginSchema, {
  password: newPassword,
  acceptLegal,
  fullName,
});

// VLT-335/065 · restablecimiento de contraseña.
export const resetRequestSchema = z.object({ email });
export type ResetRequestInput = z.infer<typeof resetRequestSchema>;

export const newPasswordSchema = z
  .object({
    password: newPassword,
    confirm: z.string(),
  })
  .check(z.refine((v) => v.password === v.confirm, {
    message: 'forms.errors.passwordMatch',
    path: ['confirm'],
  }));
export type NewPasswordInput = z.infer<typeof newPasswordSchema>;
